  <ng-container *ngIf="(policy?.billingDetails[0] && outstandingBalance > 0)
                        || ((policy?.policynumber?.policyNumber.length === 6 || (policy?.policynumber?.policyNumber.length > 6 && policy?.policyStatus === 'ACTIVE')) && (policy?.policyFlags.isEftEligible === 'Y' || policy?.policyFlags.isEdfEligible === 'Y' || policy?.policyFlags.isEbillEligible === 'Y'))">
  <div class="bn-overview-right"
    [ngClass]="{'bn-overview-right-bg' : ((((policy?.policynumber?.policyNumber.length === 6 || (policy?.policynumber?.policyNumber.length > 6 && policy?.policyStatus === 'ACTIVE'))) && (((policy?.policyFlags.isEftEligible === 'Y' && policy?.isNewPolicy && policy?.autoPay<=0 || policy?.policyFlags.isEftEligible === 'Y' && !policy?.isNewPolicy) && policy?.policyStatus === 'ACTIVE' && !((policy?.policyCancellationReason && (policy?.policyCancellationReason.toLowerCase() === 'pay - non-payment of insurance premium' || policy?.policyCancellationReason.toLowerCase() === 'fpd - failure to pay deposit') && policy?.policyFlags.isEft === 'UNENROLLED' )) && ((policy?.policyFlags.isEftEligible === 'Y') && ((policy?.billingDetails)[0]?.badCheckCount === 'N' || ((policy?.billingDetails)[0]?.badCheckCount === 'Y' && isAcmic))&& (policy?.billingDetails)[0]?.mortageeFlag === 'N')) || ((policy?.policyFlags.isEdfEligible === 'Y' && ((policy?.policyType !== 'COMMERCIAL_AUTO') && (policy?.policyType !== 'GARAGE_KEEPER')))) || ((policy?.policyFlags.isEbillEligible === 'Y') && (((policy?.policyType === 'COMMERCIAL_AUTO') && (policy?.policyType === 'GARAGE_KEEPER')))))) || (policy?.billingDetails && policy?.billingDetails[0]?.outstandingbalance !== 0))}">
    <div class="bn-paynow-sec" *ngIf="policy?.billingDetails[0] && outstandingBalance > 0">
        <div class="bn-paynow-sec-inner">
            <div class="bn-min-amt-text">
                <div (click)="isMobile && toggleTooltip($event, minAmtTooltip)">
                    {{ isAcmic ? 'Min amount due' : 'Min amount due***'}}
                </div>
                <div class="ml-1">
                    <app-info-tooltip
                        #minAmtTooltip
                        [content]="'Payments above the minimum due are evenly applied to future installments.'"
                        position="top"
                        [align]="isMobile ? 'left' : 'center'">
                    </app-info-tooltip>
                </div>
            </div>
            <div class="bn-pay-act-sec">
                <div class="bn-min-amt-val">
                    <ng-container
                        *ngIf="!policy?.billingDetails || (policy?.billingDetails && currentMinAmtDue === 0)">
                        {{'$0.00'}}
                    </ng-container>
                    <ng-container
                        *ngIf="policy?.billingDetails && policy?.billingDetails[0]?.paymentDueDate && currentMinAmtDue !== 0">
                        {{ currentMinAmtDue | currency }}
                        <ng-container
                            *ngIf="policy?.billingDetails[0].amountStillDue === 0 && policy?.hasPriorYearBalance; else hasAmountDue">
                            <span class="bn-due-date-text bn-due-date-text-mobile"
                                *ngIf="policy?.hasPriorYearBalance">{{ ' on ' }} {{
                                policy?.priorYearBalanceDueDate | customDateFormat }} </span>
                        </ng-container>
                        <ng-template #hasAmountDue>
                            <span class="bn-due-date-text bn-due-date-text-mobile"
                                *ngIf="!policy?.hasPriorYearBalance">{{ ' on ' }} {{ paymentDate |
                                customDateFormat }} </span>
                        </ng-template>
                    </ng-container>
                </div>
                <div class="mortgagee-container">
                    <ng-container *ngIf="!isAcmic && (hasMortgagee() || isPaidInFullPending); else notMortgageePaynow">
                        <mapfre-button
                            [inputType]="'submit'"
                            [ngClass]="{ custom_loader: loading }"
                            [additionalClasses]="'basic primary bn-paynow-action-btn bn-paynow-action-btn-acmic'"
                            [translateValue]="'Pay now'"
                            (click)="openMortgageeModal()">
                        </mapfre-button>
                        <app-mortgagee-modal
                            *ngIf="showMortgageeModal"
                            [policy]="policy"
                            [isPaidInFullPending]="isPaidInFullPending"
                            (closeModal)="closeModal()">
                        </app-mortgagee-modal>
                    </ng-container>
                    <ng-template #notMortgageePaynow>
                        <mapfre-button
                            [inputType]="'submit'"
                            [ngClass]="{ custom_loader: loading }"
                            [additionalClasses]="'basic primary bn-paynow-action-btn bn-paynow-action-btn-acmic'"
                            [translateValue]="'Pay now'"
                            (click)="payNow()">
                        </mapfre-button>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>

    <hr class="thin-hr width-class min-amt-hr"
        *ngIf="(policy?.billingDetails[0] && policy?.billingDetails[0]?.outstandingbalance !== 0) && (policy?.policynumber?.policyNumber.length === 6 || (policy?.policynumber?.policyNumber.length > 6 && policy?.policyStatus === 'ACTIVE')) && (policy?.policyFlags.isEftEligible === 'Y' || policy?.policyFlags.isEdfEligible === 'Y' || policy?.policyFlags.isEbillEligible === 'Y')">

    <div class="bn-paynow-sec"
        *ngIf="(policy?.policynumber?.policyNumber.length === 6 || (policy?.policynumber?.policyNumber.length > 6 && policy?.policyStatus === 'ACTIVE')) && (policy?.policyFlags.isEftEligible === 'Y' || policy?.policyFlags.isEdfEligible === 'Y' || policy?.policyFlags.isEbillEligible === 'Y')">
        <div class="bn-paynow-sec-inner" [ngClass]="{'tw-v12-enroll': company === 'TW' || company === 'V12'}">
            <ng-container
                *ngIf="((policy?.policyFlags?.isEft === 'ENROLLED' && policy?.policyFlags?.isEdf === 'ENROLLED') ||
                ((company === 'TW' || company === 'V12') && policy?.policyFlags?.isEft === 'ENROLLED')); else simplifyText">
                <div class="bn-simplify col-9CB0BC"
                    [ngClass]="{'margin-bottom mb16': (company === 'Guidewire' || company === 'AS400')}">You’re
                    enrolled in</div>
            </ng-container>
            <ng-template #simplifyText>
                <div class="bn-simplify col-9CB0BC"
                    [ngClass]="{'margin-bottom mb16': (company === 'Guidewire' || company === 'AS400')}">
                    Simplify your billing</div>
            </ng-template>
            <div class="bn-pay-act-sec justify-content-between bn-pay-act-sec-status">
                <ng-container
                    *ngIf="(policy?.policyFlags.isEftEligible === 'Y' && policy?.isNewPolicy && policy?.autoPay<=0 || policy?.policyFlags.isEftEligible === 'Y' && !policy?.isNewPolicy) && policy?.policyStatus === 'ACTIVE' && !((policy?.policyCancellationReason && (policy?.policyCancellationReason.toLowerCase() === 'pay - non-payment of insurance premium' || policy?.policyCancellationReason.toLowerCase() === 'fpd - failure to pay deposit') && policy?.policyFlags.isEft === 'UNENROLLED' ))">
                    <ng-container *ngIf="(policy?.policyFlags.isEftEligible === 'Y') &&
                        ((policy?.billingDetails)[0]?.badCheckCount === 'N' ||
                        ((policy?.billingDetails)[0]?.badCheckCount === 'Y' && isAcmic))
                        && (policy?.billingDetails)[0]?.mortageeFlag === 'N'">
                        <ng-container [ngSwitch]="policy?.policyFlags?.isEft">
                            <a class="bn-paperless-autopay-txt" *ngSwitchCase="'ENROLLED'">
                                <img src="assets/img/images/icon-check-circle-16.svg" />
                                <ng-container *ngIf="isAcmic; else maAutopay">
                                    <span [routerLink]="['/billing','autopay']" (click)="triggerDatalayer('Manage Autopay')" class="manage-autopay-paperless margin-left ml4">{{ "MANAGE_AUTOPAY" | translate }}</span>
                                </ng-container>
                                <ng-template #maAutopay>
                                    {{ "Autopay" | translate }}
                                </ng-template>
                            </a>
                            <a *ngSwitchCase="'UNENROLLED'" [routerLink]="['/billing', 'autopay']"
                                (click)="triggerDatalayer('Enroll in Autopaay')"
                                class="bn-enroll-status">
                                {{ "Enroll in autopay" | translate }}
                            </a>
                            <a *ngSwitchCase="'ENROLLMENT-PENDING'" [routerLink]="['/billing', 'autopay']"
                                class="bn-enroll-status">
                                {{ "PENDING_ENROLLMENT" | translate }}{{ " Autopay" }}
                            </a>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <ng-container
                    *ngIf="((policy?.policyType !== 'COMMERCIAL_AUTO') && (policy?.policyType !== 'GARAGE_KEEPER')); else commercialTemp">
                    <ng-container *ngIf="policy?.policyFlags.isEdfEligible === 'Y'">
                        <ng-container [ngSwitch]="true">
                            <a class="bn-paperless-autopay-txt" *ngSwitchCase="
                                policy?.policyFlags.isEdf === 'ENROLLED' ||
                                policy?.policyFlags.isEdf === 'TRUE'
                            ">
                                <img src="assets/img/images/icon-check-circle-16.svg" />
                                <ng-container *ngIf="isAcmic; else maPaperless">
                                    <span [routerLink]="['/billing', 'paperless']" (click)="triggerDatalayer('Manage Paperless')" class="manage-autopay-paperless margin-left ml4">{{ "MANAGE_PAPERLESS" | translate }}</span>
                                </ng-container>
                                <ng-template #maPaperless>
                                    {{ "Paperless" | translate }}
                                </ng-template>
                            </a>
                            <a *ngSwitchCase="
                                policy?.policyFlags.isEdf === 'UNENROLLED' ||
                                policy?.policyFlags.isEdf === 'FALSE'
                            " [routerLink]="['/billing', 'paperless']" (click)="triggerDatalayer('Enroll in Paperless')" class="bn-enroll-status">Enroll in paperless
                            </a>
                            <a *ngSwitchCase="policy?.policyFlags.isEdf==='ENROLLMENT-PENDING'"
                                [routerLink]="['/billing', 'paperless']" class="bn-enroll-status">
                                {{ "PENDING_ENROLLMENT" | translate }} {{ " Paperless" }}
                            </a>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <ng-template #commercialTemp>
                    <ng-container *ngIf="policy?.policyFlags.isEbillEligible === 'Y'">
                        <ng-container [ngSwitch]="true">
                            <a *ngSwitchCase="policy?.policyFlags.isEbill==='ENROLLED' ||
                                policy?.policyFlags.isEbill ==='TRUE'">
                                <img src="assets/img/images/icon-check-circle-16.svg" />
                                {{ "E-bill" | translate }}
                            </a>
                            <a *ngSwitchCase="policy?.policyFlags.isEbill==='UNENROLLED' || policy?.policyFlags.isEbill ==='FALSE'"
                                [routerLink]="['/billing','paperless']" class="bn-enroll-status">
                                Enroll in E-bill
                            </a>
                            <a *ngSwitchCase="policy?.policyFlags.isEbill==='ENROLLMENT-PENDING'"
                                [routerLink]="['/billing','paperless']" class="bn-enroll-status">
                                {{ "PENDING_ENROLLMENT" | translate }} {{ " E-bill" }}
                            </a>
                        </ng-container>
                    </ng-container>
                </ng-template>
            </div>
        </div>
    </div>
  </div>
</ng-container>
